import backofficeService from "../../api/backoffice";


export default {
  // -----------------------------
  // EXISTING GRADE METHODS
  // -----------------------------
  getAll(params) {
    return backofficeService
      .Api()
      .get("grade", { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  getById(id, params = {}) {
    return backofficeService
      .Api()
      .get(`grade/${id}`, { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  create(data) {
    return backofficeService
      .Api()
      .post("grade", data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  update(id, data) {
    return backofficeService
      .Api()
      .put(`grade/${id}`, data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  delete(id, params) {
    return backofficeService
      .Api()
      .delete(`grade/${id}`, { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  saveMultipleGrades(data) {
    return backofficeService
      .Api()
      .post("grade/multipleStudents", data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  // -----------------------------
  // NEW: TERM MATERIALS (TEACHER SIDE)
  // -----------------------------

  /**
   * Get assigned template for a classroom + term
   * Backend should return:
   * { assignment: {...}, template: {...} } OR { data: {...} }
   */
  getMaterialAssignment(params) {
    // params: { ClassRoomId, TermId }
    return backofficeService
      .Api()
      .get("termMaterials/assignment", { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Get saved response for classroom + term + template
   * params: { ClassRoomId, TermId, TermMaterialTemplateId }
   */
  getMaterialResponse(params) {
    return backofficeService
      .Api()
      .get("termMaterials/response", { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Create/Update response
   * payload: {
   *   TermId, ClassRoomId, TermMaterialTemplateId,
   *   TeacherId (optional),
   *   responses: { [key]: value }
   * }
   */
  saveMaterialResponse(payload) {
    return backofficeService
      .Api()
      .post("termMaterials/response", payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Optional helper: validate required fields based on template.fields
   * template.fields: [{ key, label, required, type }]
   */
  validateRequiredMaterialResponse(template, responses) {
    const fields = (template && Array.isArray(template.fields)) ? template.fields : [];
    const r = responses || {};

    for (let i = 0; i < fields.length; i++) {
      const f = fields[i];
      if (!f || !f.required) continue;

      const val = r[f.key];
      const str = (val === null || val === undefined) ? "" : String(val).trim();

      if (!str) {
        return `${f.label || "Required field"} is required.`;
      }
    }
    return null;
  },
};